export default __webpack_public_path__ + "static/proxima-nova-700-8bd27530f61597063462d84869a95719.woff2";